import React from 'react';

export const useInterval = (callback: () => void, delay?: number | null): void => {
  const prevCallback = React.useRef(callback);

  React.useEffect(() => {
    prevCallback.current = callback;
  }, [callback]);

  React.useEffect(() => {
    if (delay === null || delay === undefined) return;

    const interval = setInterval(() => {
      prevCallback.current();
    }, delay);

    return () => {
      clearInterval(interval);
    };
  }, [delay]);
};

export default useInterval;
